import React from 'react';
import { CropperPreview } from 'react-advanced-cropper';
import { Avatar } from '../../components';
import ChangeAvatarIcon from './ChangeAvatarIcon';
import PositionIcon from '../UploadImageWizard/icons/PositionIcon';
import css from './AvatarWithImage.css';

const previewState = { state: null, image: null, transitions: null };

export default ({
    onEdit,
    onAvatarClick,
    onUploadFromPc,
    profielImageId,
    avatarComponentMaybe,
    previewRef,
    previewAllowed,
    currentUser,
}) => {
    const avatarComponent = avatarComponentMaybe ? (
        <Avatar
            className={css.avatar}
            renderSizes="(max-width: 767px) 96px, 240px"
            user={currentUser}
            disableProfileLink
            previewAllowed={previewAllowed}
            avatarType="large"
        />
    ) : null;

    const startEditing = () => {
        if (profielImageId) {
            const { variants } = currentUser.profileImage.attributes;
            const squareSmall2x = variants['square-small2x'];
            onEdit(squareSmall2x.url);
        }
    };

    return (
        <>
            <div className={css.avatarContainer} onClick={onAvatarClick}>
                {avatarComponentMaybe ? (
                    avatarComponent
                ) : (
                    <CropperPreview ref={previewRef} className="preview" {...previewState} />
                )}
            </div>
            <aside className={css.changeAvatarSection}>
                <div className={css.changeAvatar} onClick={startEditing}>
                    <PositionIcon />
                    Positionieren
                </div>
                <div className={css.changeAvatar} onClick={onUploadFromPc}>
                    <ChangeAvatarIcon />
                    Ändern
                </div>
            </aside>
        </>
    );
};
